import { ref } from 'vue'
import type { ApiService } from '@nuxtDatakodeUtils/utils/api.service'
import type { I3pService } from '@nuxtDatakodeUtils/services/i3p.service'
import { fromLonLat } from 'ol/proj.js'
import { Application } from '~/models/Application'

type GenericApplicationData = PildomModules.Generic.Data.GenericApplicationData

export class ApplicationService {
    private readonly $api: ApiService
    private readonly $i18n: object
    public application: Application = new Application()
    public applicationRef: Ref<any>
    public i3pService: I3pService<any> | null = null
    public loading: boolean = true

    constructor(api: ApiService, i18n: object) {
        this.$api = api
        this.$i18n = i18n

        this.applicationRef = ref(null)
    }

    async init(): Promise<void> {
        const config = useRuntimeConfig()
        const MajicApp = new Application()
        MajicApp.setKey(config.public.app_slug)
        const application = await MajicApp.get()
        if (!application) {
            throw new Error('Application not found')
        }
        // const configStore = useConfigStore()
        // configStore.currentConfig.app_info = application
        this.application = application as Application
        this.applicationRef.value = this.application
        this.loading = false
    }

    getMapLayers(): [] {
        const mapLayers = this.application?.data?.map_layers ?? []
        return mapLayers.reverse()
    }

    getBBox(): { x_min: number, x_max: number, y_min: number, y_max: number } {
        const data = this.application?.data as GenericApplicationData
        const pt1 = fromLonLat([data.longitude_min, data.latitude_min])
        const pt2 = fromLonLat([data.longitude_max, data.latitude_max])
        return {
            x_min: pt1[0],
            x_max: pt2[0],
            y_min: pt1[1],
            y_max: pt2[1],
        }
    }
}
